import React from 'react'

import NavBar from '../components/NavBar';
import Biography from '../components/Biography';

const About = () => {
    return (
        <div>
            <NavBar />
            <Biography />
        </div>
    )
}


export default About